export default () => {
    // Sometimes if a refresh occurs while the user is hovering the chart
    // The tooltip might get stuck, this prevents this issue
    const tooltips
    = document.getElementsByClassName('nvtooltip xy-tooltip');
    for (let i = 0; i < tooltips.length; i++) {
        tooltips[i].style.opacity = 0;
    }
};



/** WEBPACK FOOTER **
 ** ./src/utils/hideNVD3Tooltip.js
 **/